<template>
  <FormsFieldsWrapper
    :name="name"
    :label="label"
    :description="description"
    :error="{ message: errorMessage }"
    :success="{
      valid: meta.valid,
      message: successMessage,
    }"
  >
    <Select
      :name="name"
      :input-id="name"
      :model-value="inputValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :loading="loading"
      :options="options"
      :option-label="optionLabel"
      :option-value="optionValue"
      class="w-full"
      :class="{ 'p-invalid': errorMessage }"
      :filter="options.length > 10"
      :show-clear="showClear"
      @change="handleChange($event.value)"
      @blur="handleBlur"
    >
      <template #value="slotProps">
        <slot
          name="value"
          v-bind="slotProps"
        />
      </template>

      <template #option="slotProps">
        <slot
          name="option"
          v-bind="slotProps"
        />
      </template>
    </Select>
  </FormsFieldsWrapper>
</template>

<script setup lang="ts">
import useFormField, { defaultProps } from './useFormField'

const props = defineProps({
  loading: { type: Boolean, default: () => false },
  options: { type: Array, required: true },
  optionLabel: { type: String, default: () => 'label' },
  optionValue: { type: String, default: () => 'value' },
  showClear: { type: Boolean, default: () => false },
  ...defaultProps,
})

const { name, inputValue, errorMessage, handleBlur, handleChange, meta }
  = useFormField(props)
</script>
